export default __webpack_public_path__ + "static/12-skeena-east-label-ac8343f427f7d403260341e97617947d.svg";